// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mwg_effect030 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font: 400 normal 15px / normal 'Satoshi', sans-serif;
  letter-spacing: -0.03em;
  background: #121212;
  color: #F1F1F1;
  padding: 120px 0 60px;
  position: relative;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

.portfolio-heading-banner {
  width: 100%;
  max-width: 1400px;
  padding: 4vw 80px;
  margin: 0 auto 5vw;
  display: flex;
  align-items: center;
}

.heading-content {
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}

.heading-line {
  font: 500 normal 6vw/0.9 "Satoshi", sans-serif;
  letter-spacing: -0.05em;
  color: #F1F1F1;
  display: flex;
  align-items: center;
  gap: 0.5vw;
}

.sparkle-emoji {
  font-size: 6vw;
  line-height: 0.9;
  display: inline-block;
}

.mwg_effect030 ul.portfolio-items-list {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  max-width: 1400px;
  margin: 0 auto;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mwg_effect030 ul.portfolio-items-list li.portfolio-item {
  display: block;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0;
  cursor: pointer;
  transition: background 0.2s ease;
}

.mwg_effect030 ul.portfolio-items-list li.portfolio-item:hover {
  background: rgba(255, 255, 255, 0.02);
}

.portfolio-item-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 60px 80px;
  max-width: 100%;
  margin: 0 auto;
}

.portfolio-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 24px;
}

.portfolio-item-header-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
}

.portfolio-item-title {
  font: 500 normal 2.5rem/1.2 "Satoshi", sans-serif;
  letter-spacing: -0.03em;
  color: #F1F1F1;
  margin: 0;
}

.portfolio-item-subtitle {
  font: 400 normal 0.875rem/1.4 "Satoshi", sans-serif;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.portfolio-item-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  color: #F1F1F1;
  font: 400 normal 0.9375rem/1.4 "Satoshi", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.portfolio-item-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateX(4px);
}

.portfolio-item-button:active {
  transform: translateX(2px);
}

.portfolio-item-button span {
  display: inline-block;
}

.portfolio-item-description {
  font: 400 normal 1rem/1.6 "Satoshi", sans-serif;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  max-width: 85%;
  margin-top: 16px;
}

.portfolio-item-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.portfolio-item-image-section {
  display: flex;
  align-items: start;
  justify-content: center;
}

.portfolio-item-image-wrapper {
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.portfolio-item-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

.portfolio-item-features {
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: start;
}

.portfolio-feature {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.portfolio-feature-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F1F1F1;
}

.portfolio-feature-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.portfolio-feature-title {
  font: 500 normal 1.125rem/1.3 "Satoshi", sans-serif;
  letter-spacing: -0.02em;
  color: #F1F1F1;
  margin: 0;
}

.portfolio-feature-description {
  font: 400 normal 0.9375rem/1.6 "Satoshi", sans-serif;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.mwg_effect030 .media-container {
  position: fixed;
  width: 24vw;
  height: 24vw;
  max-width: 400px;
  max-height: 400px;
  right: 16%;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2%;
  pointer-events: none;
  overflow: hidden;
  visibility: hidden;
  z-index: 100;
}

.mwg_effect030 .media-container.on {
  visibility: visible;
}

.mwg_effect030 .media-container div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transform: translate(0, -100%);
}

.mwg_effect030 .media-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0, 90%);
}

.mwg_effect030 .media-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(0, 90%);
}

.mwg_effect030 .medias img {
  width: 1px;
  height: 1px;
  top: 0;
  left: 0;
  position: absolute;
  visibility: hidden;
  pointer-events: none;
}

/* Mobile Responsive */
@media (max-width: 1024px) {
  .mwg_effect030 {
    padding: 100px 0 40px;
  }

  .portfolio-heading-banner {
    padding: 4vw 60px;
    margin-bottom: 4vw;
  }

  .mwg_effect030 ul.portfolio-items-list {
    max-width: 100%;
  }

  .portfolio-item-content {
    gap: 40px;
    padding: 50px 60px;
  }

  .portfolio-item-header {
    gap: 20px;
  }

  .portfolio-item-title {
    font-size: 2rem;
  }

  .portfolio-item-button {
    padding: 10px 20px;
    font-size: 0.875rem;
  }

  .portfolio-item-description {
    max-width: 90%;
    margin-top: 14px;
  }

  .portfolio-item-body {
    gap: 50px;
  }

  .mwg_effect030 .media-container {
    width: 30vw;
    height: 30vw;
    max-width: 300px;
    max-height: 300px;
    right: 10%;
  }
}

@media (max-width: 768px) {
  .mwg_effect030 {
    padding: 100px 0 40px;
  }

  .portfolio-heading-banner {
    padding: 5vw 24px;
    margin-bottom: 5vw;
  }

  .heading-line {
    font-size: 8vw;
  }

  .sparkle-emoji {
    font-size: 8vw;
  }

  .mwg_effect030 ul.portfolio-items-list {
    max-width: 100%;
  }

  .portfolio-item-content {
    gap: 32px;
    padding: 40px 24px;
  }

  .portfolio-item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .portfolio-item-header-left {
    width: 100%;
  }

  .portfolio-item-title {
    font-size: 1.75rem;
  }

  .portfolio-item-button {
    width: 100%;
    justify-content: center;
    padding: 12px 24px;
  }

  .portfolio-item-description {
    font-size: 0.9375rem;
    max-width: 100%;
    margin-top: 12px;
  }

  .portfolio-item-body {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .portfolio-item-features {
    gap: 24px;
  }

  .portfolio-feature {
    gap: 16px;
  }

  .portfolio-feature-icon {
    width: 40px;
    height: 40px;
  }

  .portfolio-feature-title {
    font-size: 1rem;
  }

  .portfolio-feature-description {
    font-size: 0.875rem;
  }

  .mwg_effect030 .media-container {
    display: none;
  }
}

@media (max-width: 480px) {
  .mwg_effect030 {
    padding: 80px 0 32px;
  }

  .portfolio-heading-banner {
    padding: 6vw 20px;
    margin-bottom: 6vw;
  }

  .heading-line {
    font-size: 10vw;
  }

  .sparkle-emoji {
    font-size: 10vw;
  }

  .portfolio-item-content {
    padding: 32px 20px;
    gap: 28px;
  }

  .portfolio-item-header {
    gap: 14px;
  }

  .portfolio-item-title {
    font-size: 1.5rem;
  }

  .portfolio-item-subtitle {
    font-size: 0.8125rem;
  }

  .portfolio-item-button {
    padding: 10px 20px;
    font-size: 0.875rem;
  }

  .portfolio-item-description {
    font-size: 0.875rem;
    margin-top: 10px;
  }

  .portfolio-item-body {
    gap: 28px;
  }

  .portfolio-item-features {
    gap: 20px;
  }

  .portfolio-feature-icon {
    width: 36px;
    height: 36px;
  }

  .portfolio-feature-title {
    font-size: 0.9375rem;
  }

  .portfolio-feature-description {
    font-size: 0.8125rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/portfolio/portfolio.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oDAAoD;EACpD,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,iBAAiB;EACjB,cAAc;EACd,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,8CAA8C;EAC9C,UAAU;EACV,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,+BAA+B;EAC/B,SAAS;EACT,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,oDAAoD;EACpD,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".mwg_effect030 {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font: 400 normal 15px / normal 'Satoshi', sans-serif;\n  letter-spacing: -0.03em;\n  background: #121212;\n  color: #F1F1F1;\n  padding: 120px 0 60px;\n  position: relative;\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\n.portfolio-heading-banner {\n  width: 100%;\n  max-width: 1400px;\n  padding: 4vw 80px;\n  margin: 0 auto 5vw;\n  display: flex;\n  align-items: center;\n}\n\n.heading-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5vw;\n}\n\n.heading-line {\n  font: 500 normal 6vw/0.9 \"Satoshi\", sans-serif;\n  letter-spacing: -0.05em;\n  color: #F1F1F1;\n  display: flex;\n  align-items: center;\n  gap: 0.5vw;\n}\n\n.sparkle-emoji {\n  font-size: 6vw;\n  line-height: 0.9;\n  display: inline-block;\n}\n\n.mwg_effect030 ul.portfolio-items-list {\n  width: 100%;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  max-width: 1400px;\n  margin: 0 auto;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.mwg_effect030 ul.portfolio-items-list li.portfolio-item {\n  display: block;\n  width: 100%;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 0;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.mwg_effect030 ul.portfolio-items-list li.portfolio-item:hover {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.portfolio-item-content {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding: 60px 80px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.portfolio-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 24px;\n}\n\n.portfolio-item-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.portfolio-item-title {\n  font: 500 normal 2.5rem/1.2 \"Satoshi\", sans-serif;\n  letter-spacing: -0.03em;\n  color: #F1F1F1;\n  margin: 0;\n}\n\n.portfolio-item-subtitle {\n  font: 400 normal 0.875rem/1.4 \"Satoshi\", sans-serif;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.portfolio-item-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  color: #F1F1F1;\n  font: 400 normal 0.9375rem/1.4 \"Satoshi\", sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.portfolio-item-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateX(4px);\n}\n\n.portfolio-item-button:active {\n  transform: translateX(2px);\n}\n\n.portfolio-item-button span {\n  display: inline-block;\n}\n\n.portfolio-item-description {\n  font: 400 normal 1rem/1.6 \"Satoshi\", sans-serif;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n  max-width: 85%;\n  margin-top: 16px;\n}\n\n.portfolio-item-body {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: start;\n}\n\n.portfolio-item-image-section {\n  display: flex;\n  align-items: start;\n  justify-content: center;\n}\n\n.portfolio-item-image-wrapper {\n  width: 100%;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.portfolio-item-image {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  display: block;\n  border-radius: 8px;\n}\n\n.portfolio-item-features {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  justify-content: start;\n}\n\n.portfolio-feature {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.portfolio-feature-icon {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #F1F1F1;\n}\n\n.portfolio-feature-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.portfolio-feature-title {\n  font: 500 normal 1.125rem/1.3 \"Satoshi\", sans-serif;\n  letter-spacing: -0.02em;\n  color: #F1F1F1;\n  margin: 0;\n}\n\n.portfolio-feature-description {\n  font: 400 normal 0.9375rem/1.6 \"Satoshi\", sans-serif;\n  color: rgba(255, 255, 255, 0.7);\n  margin: 0;\n}\n\n.mwg_effect030 .media-container {\n  position: fixed;\n  width: 24vw;\n  height: 24vw;\n  max-width: 400px;\n  max-height: 400px;\n  right: 16%;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 2%;\n  pointer-events: none;\n  overflow: hidden;\n  visibility: hidden;\n  z-index: 100;\n}\n\n.mwg_effect030 .media-container.on {\n  visibility: visible;\n}\n\n.mwg_effect030 .media-container div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  transform: translate(0, -100%);\n}\n\n.mwg_effect030 .media-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(0, 90%);\n}\n\n.mwg_effect030 .media-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate(0, 90%);\n}\n\n.mwg_effect030 .medias img {\n  width: 1px;\n  height: 1px;\n  top: 0;\n  left: 0;\n  position: absolute;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* Mobile Responsive */\n@media (max-width: 1024px) {\n  .mwg_effect030 {\n    padding: 100px 0 40px;\n  }\n\n  .portfolio-heading-banner {\n    padding: 4vw 60px;\n    margin-bottom: 4vw;\n  }\n\n  .mwg_effect030 ul.portfolio-items-list {\n    max-width: 100%;\n  }\n\n  .portfolio-item-content {\n    gap: 40px;\n    padding: 50px 60px;\n  }\n\n  .portfolio-item-header {\n    gap: 20px;\n  }\n\n  .portfolio-item-title {\n    font-size: 2rem;\n  }\n\n  .portfolio-item-button {\n    padding: 10px 20px;\n    font-size: 0.875rem;\n  }\n\n  .portfolio-item-description {\n    max-width: 90%;\n    margin-top: 14px;\n  }\n\n  .portfolio-item-body {\n    gap: 50px;\n  }\n\n  .mwg_effect030 .media-container {\n    width: 30vw;\n    height: 30vw;\n    max-width: 300px;\n    max-height: 300px;\n    right: 10%;\n  }\n}\n\n@media (max-width: 768px) {\n  .mwg_effect030 {\n    padding: 100px 0 40px;\n  }\n\n  .portfolio-heading-banner {\n    padding: 5vw 24px;\n    margin-bottom: 5vw;\n  }\n\n  .heading-line {\n    font-size: 8vw;\n  }\n\n  .sparkle-emoji {\n    font-size: 8vw;\n  }\n\n  .mwg_effect030 ul.portfolio-items-list {\n    max-width: 100%;\n  }\n\n  .portfolio-item-content {\n    gap: 32px;\n    padding: 40px 24px;\n  }\n\n  .portfolio-item-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .portfolio-item-header-left {\n    width: 100%;\n  }\n\n  .portfolio-item-title {\n    font-size: 1.75rem;\n  }\n\n  .portfolio-item-button {\n    width: 100%;\n    justify-content: center;\n    padding: 12px 24px;\n  }\n\n  .portfolio-item-description {\n    font-size: 0.9375rem;\n    max-width: 100%;\n    margin-top: 12px;\n  }\n\n  .portfolio-item-body {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .portfolio-item-features {\n    gap: 24px;\n  }\n\n  .portfolio-feature {\n    gap: 16px;\n  }\n\n  .portfolio-feature-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .portfolio-feature-title {\n    font-size: 1rem;\n  }\n\n  .portfolio-feature-description {\n    font-size: 0.875rem;\n  }\n\n  .mwg_effect030 .media-container {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .mwg_effect030 {\n    padding: 80px 0 32px;\n  }\n\n  .portfolio-heading-banner {\n    padding: 6vw 20px;\n    margin-bottom: 6vw;\n  }\n\n  .heading-line {\n    font-size: 10vw;\n  }\n\n  .sparkle-emoji {\n    font-size: 10vw;\n  }\n\n  .portfolio-item-content {\n    padding: 32px 20px;\n    gap: 28px;\n  }\n\n  .portfolio-item-header {\n    gap: 14px;\n  }\n\n  .portfolio-item-title {\n    font-size: 1.5rem;\n  }\n\n  .portfolio-item-subtitle {\n    font-size: 0.8125rem;\n  }\n\n  .portfolio-item-button {\n    padding: 10px 20px;\n    font-size: 0.875rem;\n  }\n\n  .portfolio-item-description {\n    font-size: 0.875rem;\n    margin-top: 10px;\n  }\n\n  .portfolio-item-body {\n    gap: 28px;\n  }\n\n  .portfolio-item-features {\n    gap: 20px;\n  }\n\n  .portfolio-feature-icon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .portfolio-feature-title {\n    font-size: 0.9375rem;\n  }\n\n  .portfolio-feature-description {\n    font-size: 0.8125rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
